export const PAYMENT_METHODS_PROVIDER_NAMES = {
    ALTERNATE_PAYMENTS: 'alternate_payments',

    // all
    CRYPTOWALLETS: 'cryptowallets',

    // ph
    ECOMMPAY_GCASH: 'ecommpay_gcash',
    GCASH: 'gcash',

    // br
    DIRECT_PIX: 'direct_pix',
    PIX: 'pix',

    // id
    QRIS: 'qris',
    DANA: 'dana',
    OVO: 'ovo',
    LINKAJA: 'linkaja',
    SHOPEE_PAY: 'shopee_pay',
    VA_CIMB: 'va_Cimb',
    VA_BNI: 'va_bni',
    VA_BRI: 'va_bri',
    VA_MANDIRI: 'va_mandiri',
    VA_PERMATA: 'va_permata',
    GO_PAY: 'go_pay',
    KOALA_FIRST_INTERNET_BANKING_ID: 'koala_first_internet_banking_id',

    // in
    PAYOK_UPI: 'payok_upi',
    PAYOK_IMPS: 'payok_imps',
} as const;

interface IPaymentConfig {
    fullIcon?: string,
    icon: string,
}

export type PaymentConfigKeys = typeof PAYMENT_METHODS_PROVIDER_NAMES[keyof typeof PAYMENT_METHODS_PROVIDER_NAMES];

export const PAYMENT_CONFIG: { [key in PaymentConfigKeys]: IPaymentConfig } = {
    [PAYMENT_METHODS_PROVIDER_NAMES.ALTERNATE_PAYMENTS]: {
        icon: 'IcPaymentMethod',
    },
    [PAYMENT_METHODS_PROVIDER_NAMES.DIRECT_PIX]: {
        fullIcon: 'IcPixFull',
        icon: 'IcPix',
    },
    [PAYMENT_METHODS_PROVIDER_NAMES.ECOMMPAY_GCASH]: {
        icon: 'IcGcash',
    },
    [PAYMENT_METHODS_PROVIDER_NAMES.GCASH]: {
        icon: 'IcGcash',
    },
    [PAYMENT_METHODS_PROVIDER_NAMES.PIX]: {
        fullIcon: 'IcPixFull',
        icon: 'IcPix',
    },
    [PAYMENT_METHODS_PROVIDER_NAMES.QRIS]: { icon: 'IcQris' },
    [PAYMENT_METHODS_PROVIDER_NAMES.DANA]: { icon: 'IcDana' },
    [PAYMENT_METHODS_PROVIDER_NAMES.OVO]: { icon: 'IcOvo' },
    [PAYMENT_METHODS_PROVIDER_NAMES.LINKAJA]: { icon: 'IcLinkaja' },
    [PAYMENT_METHODS_PROVIDER_NAMES.SHOPEE_PAY]: { icon: 'IcShopeepay' },
    [PAYMENT_METHODS_PROVIDER_NAMES.VA_CIMB]: { icon: 'IcCimb' },
    [PAYMENT_METHODS_PROVIDER_NAMES.VA_BNI]: { icon: 'IcNegara' },
    [PAYMENT_METHODS_PROVIDER_NAMES.VA_BRI]: { icon: 'IcBriVa' },
    [PAYMENT_METHODS_PROVIDER_NAMES.VA_MANDIRI]: { icon: 'IcMandiri' },
    [PAYMENT_METHODS_PROVIDER_NAMES.VA_PERMATA]: { icon: 'IcPermata' },
    [PAYMENT_METHODS_PROVIDER_NAMES.GO_PAY]: { icon: 'IcGoPay' },
    [PAYMENT_METHODS_PROVIDER_NAMES.KOALA_FIRST_INTERNET_BANKING_ID]: { icon: 'IcKoalaIb' },
    [PAYMENT_METHODS_PROVIDER_NAMES.CRYPTOWALLETS]: { icon: 'IcCrypto' },
    [PAYMENT_METHODS_PROVIDER_NAMES.PAYOK_UPI]: { icon: 'IcUpi' },
    [PAYMENT_METHODS_PROVIDER_NAMES.PAYOK_IMPS]: { icon: 'IcImps' },
};

export const DEFAULT_PAYMENT_URL_EXPIRY_MINUTES = 10;
